import React, { useState } from "react";
import { Button, Container, Row, Col, Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import HeaderChatBoat from "./HeaderChatBoat";

function EditInput() {
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

    return (
        <>
            <HeaderChatBoat />
            <section
                className="content-height"
                style={{ overflowY: "hidden", minHeight: "89vh" }}
            >
                <div className="d-flex flex-column mt-60px" style={{ height: '90vh!important' }}>
                    <Container fluid className="flex-grow-1 p-0">
                        <Row className="h-100 g-0">

                            {/* ---------- Fixed Sidebar ---------- */}
                            <div
                                className="border-end d-flex flex-column p-3 bg-white"
                                style={{
                                    position: "fixed",
                                    top: "60px",
                                    left: 0,
                                    bottom: 0,
                                    width: sidebarOpen ? "350px" : "60px",
                                    transition: "width 0.3s ease",
                                    whiteSpace: "nowrap",
                                    overflowY: "auto",
                                    zIndex: 1000,
                                }}
                            >
                                {sidebarOpen && (
                                    <div className="d-flex flex-column gap-3 p-2">
                                        <div className="row mt-5 sideBarBox">
                                            <div className="col-sm-12 col-md-12 col-lg-12">
                                                <button className="btn btn-chat w-100">+ New Chat</button>

                                                <h6 className="mt-3">Recent</h6>

                                                <div className="d-flex justify-content-between align-items-center recentChat mb-2">
                                                    <div>Recent Chat</div>
                                                    <div><img src="/assets/images/more.png" /></div>
                                                </div>
                                                <button className="btn btn-newchat"> New Chat</button>
                                                <h6 className="mt-3">Yesterday</h6>
                                                <div className="d-flex flex-column text-start">
                                                    <button className="btn btn-newchat mb-1"> New Chat</button>
                                                    <button className="btn btn-newchat mb-1"> New Chat</button>
                                                    <button className="btn btn-newchat mb-1"> New Chat</button>
                                                    <button className="btn btn-newchat mb-1"> New Chat</button>
                                                    <button className="btn btn-newchat mb-1"> New Chat</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <Button
                                    size="sm"
                                    onClick={toggleSidebar}
                                    className="position-absolute btn bg-white border-0"
                                    style={{
                                        right: "14px",
                                        borderRadius: "50%",
                                        zIndex: 5,
                                        width: "30px",
                                        height: "30px",
                                        padding: 0,
                                        top: "20px",
                                        boxShadow: "none",
                                    }}
                                    title={sidebarOpen ? "Collapse sidebar" : "Expand sidebar"}
                                >
                                    <img
                                        src="/assets/images/Layout.png"
                                        height={20}
                                        alt="toggle"
                                    />
                                </Button>
                            </div>

                            {/* ---------- Main Chat Area ---------- */}
                            <Col
                                className="d-flex flex-column"
                                style={{
                                    marginLeft: sidebarOpen ? "350px" : "60px",
                                    transition: "margin-left 0.3s ease",
                                }}
                            >
                                <div
                                    className="flex-grow-1 p-3 overflow-auto"
                                    style={{ height: "72vh", overflowY: "scroll" }}
                                >
                                    <div className="row">
                                        <div className="col-sm-12 col-md-12 col-lg-12">
                                            <div className="px-5 pt-3">
                                                <div className="card rightChatBox">
                                                    <div className="card-body">
                                                        <div className="scrollBox" >
                                                            <p><img src="/assets/images/fish.png" className="mb-2" /></p>
                                                            <p><strong>Name  </strong> <span>Oreochromis macrochir</span></p>
                                                            <p><strong>last week’s recorded temperature  </strong> <span> 32.4 C</span></p>
                                                            <p><strong>next week’s forecast temperature  </strong> <span>45 C</span></p>
                                                            <p>Generated advisory based on last week observed rainfall and next 2 weeks forecast You may modify/rewrite the message before sending:</p>



                                                            <p className="mb-0"> --------------EMERGENCY!!!---------------------t</p>
                                                            <p className="mb-0"> Water temperature is reaching 12°C!!!</p>
                                                            <p className="mb-0"> Water temperature is predicted to increase to high-risk levels over the next 8 to 12 hours.</p>
                                                            <p className="mb-0"> Water temperature that is too high or too low affects fish health. Water temperature affects key parameters that can
                                                                also affect fish health, such as dissolved Oxygen, pH, ammonia, nitrite.</p>
                                                            <p className="mb-0"> --------------MONITORING:--------------------</p>
                                                            <p className="mb-0"> Monitor the following parameters:</p>
                                                            <p className="mb-0">  Water temperature, air temperature, Dissolved Oxygen (DO), pH, ammonia, nitrite, and fish behaviors.</p>
                                                            <p className="mb-0"> FREQUENCY:</p>
                                                            <p className="mb-0"> Every 4 hours during the day and night - 06h00, 10h00, 14h00, 18h00, 22h00, 02h00)</p>

                                                            <p className="mb-0"> --------------MITIGATION:--------------------</p>
                                                            <p className="mb-0"> FLUSHING: If any measurements exceed the below values, PLEASE add freshwater from the
                                                                water source, continue to monitor at the outlet; once a parameter has decreased below
                                                                the level below, stop adding water.</p>

                                                            <p className="mb-0">FEEDING/FERTILIZING: If any measurements exceed the below values, PLEASE reduce the number
                                                                of feeds by 1 and also feed slowly until fish stop feeding.</p>

                                                            <p className="mb-0">BEHAVIOR: If fish display any stress-related behavior such as gasping for air at the
                                                                surface, swimming or lying on the side, or floating still at the surface but still moving,
                                                                PLEASE prepare to harvest fish or move them to another pond with temperature, DO, pH,
                                                                ammonia, and nitrite in safe limits.</p>


                                                            <p className="mb-0">Temperature &lt; 14°C</p>
                                                            <p className="mb-0">DO  &lt; 6 mg/l</p>
                                                            <p className="mb-0">pH increasing to 9 or more</p>
                                                            <p className="mb-0">pH decreasing to 7 or less</p>
                                                            <p className="mb-0"> Ammonia XXX</p>
                                                            <p className="mb-0"> Nitrite XXX</p>
                                                        </div>
                                                    </div>

                                                    <div className="card-footer">
                                                        <ul className="d-flex fixedFooterTool">
                                                            <li><img src="/assets/images/sound.png" /></li>
                                                            <li><img src="/assets/images/copy.png" /></li>
                                                            <li><img src="/assets/images/repeat.png" /></li>
                                                            <li><img src="/assets/images/thumbsdown.png" /></li>
                                                            <li><img src="/assets/images/magic.png" /></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="bg-white mx-100px">
                                    <div className="card">
                                        <div className="card-body p-0">
                                            <input
                                                type="text"
                                                className="form-control bg-white h42px border-0"
                                                placeholder="Send a message..."
                                            />
                                        </div>
                                        <div className="card-footer bg-white p-0">
                                            <div className="d-flex justify-content-between align-items-center p-1">
                                                <div>
                                                    <button className="btn btnActionButton me-3"><span className="me-2"><img src="/assets/images/message.png" /></span> Browse Prompts</button>
                                                     <button className="btn btnActionButton me-3"><span className="me-2"><img src="/assets/images/attach.png" /></span> Attach</button>
                                                      <button className="btn btnActionButton me-3"><span className="me-2"><img src="/assets/images/setting.png" /></span> Settings</button>
                                                </div>
                                                <div>
                                                     <button className="btn btnActionButton p-0"><span className=""><img src="/assets/images/send.png" /></span></button>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                     <p className="mb-0 textError">Chatbot can make mistakes sometimes, please double check</p>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </section>
        </>
    );
}

export default EditInput;
